const parentRouter = [
  {
    label: '资源管理',
    path: ''
  }
]
const routes = [
  {
    path: '/resourceAdmin/template',
    name: 'template',
    meta: {
      title: '模版管理',
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/resourceAdmin/views/template.vue')
  }
]
export default routes
